import { Card, Grid, ValidationErrors, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import {
  StaffReportServiceDetailReportBy,
  StaffReportServiceDetailReportByResource
} from "generated/openApi";
import produce from "immer";

export const ServiceDetailReportBy = (props: {
  reportBy: StaffReportServiceDetailReportBy;
  setReportBy: (reportBy: StaffReportServiceDetailReportBy) => void;
  resource: StaffReportServiceDetailReportByResource;
  validationErrors: ValidationErrors | string[];
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const properties = props.resource.properties || [];

  const reportByField = () => {
    const propertyName = pn<StaffReportServiceDetailReportBy>("reportById");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.resource.reportByItems?.find((x) => x.id === props.reportBy.reportById)}
        options={props.resource.reportByItems}
        getOptionLabel={option => option.name}
        onChange={(e, value) =>
          props.setReportBy(
            produce(props.reportBy, (draft) => {
              draft.reportById = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Card>
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })}>
          {reportByField()}
        </Grid>
      </Grid>
    </Card>
  );
};
